import React from "react";
import reactStringReplace from "react-string-replace";
import { QueryParam } from "./QueryParam";

export interface IProps {
    children: React.ReactNode;
}

const QUERY_REPLACEMENT_REGEX = /(\$query-param-{[^\s]*})/g;

export const ReplaceQueryParams: React.FunctionComponent<IProps> = ({ children }) => {
  const childrenToRender = !Array.isArray(children) ? [children] : children;

  return (
    <>
      {reactStringReplace(childrenToRender, QUERY_REPLACEMENT_REGEX, (match, i) => <QueryParam key={i} match={match} />)}
    </>
  );
};
ReplaceQueryParams.displayName = "ReplaceQueryParams";
